import { cn } from "@/lib/utils";

interface WizardProgressBarProps {
  currentStep: number;
  totalSteps?: number;
  complete?: boolean;
}

export function WizardProgressBar({
  currentStep,
  totalSteps = 5,
  complete = false,
}: WizardProgressBarProps) {
  return (
    <div className="flex gap-1.5">
      {Array.from({ length: totalSteps }).map((_, i) => {
        const stepNum = i + 1;
        const filled = complete || stepNum <= currentStep;
        return (
          <div
            key={i}
            className={cn(
              "flex-1 h-1 rounded-full transition-colors duration-300",
              filled
                ? complete
                  ? "bg-[var(--success)]"
                  : "bg-brand"
                : "bg-border"
            )}
          />
        );
      })}
    </div>
  );
}
